/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import { useAuth } from '../context/AuthContext';
import { usePermission } from './usePermission';

import { resolveUserRoleAccess } from '../utils/user-authority.utils';

/** Central administration remains distinct from effective tenant/product permissions. */
export function useRoleAccess() {
  const { user } = useAuth();
  const { hasPermission } = usePermission();
  const access = resolveUserRoleAccess(user);
  const canViewManagement = access.canViewManagement || (user?.userKind === 'INTERNAL'
    && ['dashboard:read', 'company:read', 'user:read', 'role:read', 'organization:read'].some(hasPermission));
  return {
    ...access,
    canViewManagement,
    isUserSettingsOnly: !canViewManagement,
    canViewSystemSettings: user?.userKind === 'INTERNAL' && hasPermission('settings:system'),
    canAccessPermission: (permission: string) => user?.userKind === 'INTERNAL' && hasPermission(permission),
  };
}
